import { LoadingLifecycle } from './types';

export type SetFulfilled = <T>(entity: T) => LoadingLifecycle<T>;
export const setFulfilled: SetFulfilled = (entity) => ({
  pending: false,
  fulfilled: entity,
  rejected: undefined,
});
